export enum WarnTypes {
  PaymentExemption = 1,
  DueReminders = 2,
  ExpiringOrders = 3
}